export default __webpack_public_path__ + "static/media/background.20a2865e.jpg";